import { AppInsights } from '@/appInsights';
import { CMPApi } from '@/modules/cmp-api';
import { EoiFormView } from '@/modules/typescript-cmpApi-client/models';
import store from '@/store';
import { EventEmitter } from 'events';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import EoiWording from '../../assets/config/eoi-wording.json';

@Options({
  props: {
    eoi: {}
  },
  emits: ['update:eoi']
})
export default class Application extends Vue {
  eoi!: EoiFormView;
  
  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  private isLsNswStaff = false;
  private maxLength = 3000;
  private textCount1 = 0;
  private textCount2 = 0;
  private textCount3 = 0;
  private textCount4 = 0;

  private committeeYear = '';

  get pageHeader(): string {
    return EoiWording[0].application['pageHeader']
  }

  get pageBody(): string {
    return EoiWording[0].application['pageBody']
  }


  mounted() {
    this.eventCtrl.emit('isLoadingData', true);
    this.eventCtrl.emit('canSubmit', false);
    this.getIsLsNswStaff();
  }

  private getIsLsNswStaff() {
    const memberDetail = store.getters.getMyMemberDetails;
    if (memberDetail == null) {
      this.apiService.memberApi?.apiV1MemberGetMyMemberDetailGet()
        .then((res: any) => {
          store.dispatch('setMyMemberDetails', res.data.data);
          const personalDetail = res.data.data.personalDetail;
          this.isLsNswStaff = personalDetail.isLsNswStaff;
          this.eventCtrl.emit('canSubmit', this.isLsNswStaff);
          this.committeeYear = this.eoi.year.committeeYear;
          this.initTextArea();
          this.eventCtrl.emit('isLoadingData', false);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Member Details: ' + err.response.status);
          this.ai.trackException('Error getting details info: ' + err);
          this.eventCtrl.emit('isLoadingData', false);
        })

    } else {
      // already in cache.
      this.isLsNswStaff = memberDetail.personalDetail.isLsNswStaff;
      this.eventCtrl.emit('canSubmit', this.isLsNswStaff);
      this.initTextArea();
      this.eventCtrl.emit('isLoadingData', false);
    }

  }

  private initTextArea() {
    if (this.eoi.response1) {
      this.textCount(1);
    } else {
      this.eoi.response1 = '';
    }
    if (this.eoi.response2) {
      this.textCount(2);
    } else  {
      this.eoi.response2 = '';
    }
    if (this.eoi.response3) {
      this.textCount(3);
    } else {
      this.eoi.response3 = '';
    }
    if (this.eoi.response4) {
      this.textCount(4);
    } else {
      this.eoi.response4 = '';
    }
    this.mandatoryCheck();
  }
  
  private textCount(n: number){
    // console.log('text1: ', this.eoi.response1.length);
    switch(n){
      case 1:
        this.textCount1 = this.eoi.response1.length;
        break;
      case 2:
        this.textCount2 = this.eoi.response2.length;
        break;
      case 3:
        this.textCount3 = this.eoi.response3.length;
        break;
      case 4:
        this.textCount4 = this.eoi.response4.length;
        break;
    }

    this.mandatoryCheck();

  }

  private mandatoryCheck() {
    const _text1Valid = this.eoi.response1 !== '' && this.eoi.response1.length < 3001;
    const _text2Valid = this.eoi.response2 !== '' && this.eoi.response2.length < 3001;
    const _text3Valid = this.eoi.response3 !== '' && this.eoi.response3.length < 3001;
    const _text4Valid = this.eoi.response4.length < 3001;
  
    const el1 = this.$refs.textarea1 as HTMLElement;
    el1.className = _text1Valid ? 'has-success' : 'has-error';

    const el2 = this.$refs.textarea2 as HTMLElement;
    el2.className = _text2Valid ? 'has-success' : 'has-error';

    const el3 = this.$refs.textarea3 as HTMLElement;
    el3.className = _text3Valid ? 'has-success' : 'has-error';

    const el4 = this.$refs.textarea4 as HTMLElement;
    el4.className = _text4Valid ? 'has-success' : 'has-error';
    
    // console.log('application page: ', _text1Valid, _text2Valid, _text3Valid);
    this.eventCtrl.emit('canSubmit', this.isLsNswStaff || _text1Valid && _text2Valid && _text3Valid && _text4Valid);
  }
  
}
